import React, {useEffect, useState} from 'react';
import {clsx} from "clsx";

const ToggleSwitch = ({title, onChange, toggleSwitch, name, className}) => {
    const [isToggled, setIsToggled] = useState(false);

    const handleToggle = () => {
        setIsToggled(!isToggled);
        onChange && onChange({target: {name, value: !isToggled}});
    };

    useEffect(() => {
        if (toggleSwitch) setIsToggled(toggleSwitch)
    }, [toggleSwitch])

    return (
        <div className={clsx("flex items-center w-full max-w-md p-4 font-sans bg-white", className && className)}>
            {title && <span className="flex-grow text-sm">{title}</span>}
            <div
                className={`relative inline-block w-10 h-5 rounded-full cursor-pointer transition-colors ease-in-out duration-200 ${
                    isToggled ? 'bg-green-500' : 'bg-[#EFEFEF]'
                }`}
                onClick={handleToggle}
            >
                <div
                    className={`absolute top-1 w-3 h-3 rounded-full transition-transform duration-200 ease-in-out ${
                        isToggled ? 'transform translate-x-6 bg-white' : 'transform translate-x-1 bg-[#C2C2C2]'
                    }`}
                />
            </div>
        </div>
    );
};

export default ToggleSwitch;